<template>
  <div>
    <div class="utils__title mb-3">
      <div class="tranTop">
        <strong class="text-uppercase font-size-16">{{
          $t("admin.transaction.title")
        }}</strong>
        <a href="/addtran">
          <a-button type="primary" icon="plus-circle" style="float: right"
            >{{ $t("addTran") }}
          </a-button>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-table
              :columns="columns"
              :rowKey="(record) => record.id"
              :dataSource="transactions"
              :loading="loading"
              :pagination="pagination"
            >
              <template slot="stt" slot-scope="id, record, index">
                {{ index + 1 }}
              </template>
              <template slot="name" slot-scope="title, record">
                <router-link :to="`/admin/transaction/${record.id}`">{{
                  record.displayName || record.phoneNumber || record.id
                }}</router-link>
              </template>
              <template slot="time" slot-scope="time">
                {{ time | formatDate }}
              </template>
              <template slot="Current plan" slot-scope="plan">
                {{ plan }}
              </template>
              <template slot="status" slot-scope="status">
                <span :class="`status_${status}`">{{
                  $t("transaction.status_" + status)
                }}</span>
              </template>
            </a-table>
          </div>
        </div>
        <div class="text-uppercase tranTop font-size-14">
          {{ $t("admin.transaction.title-cash") }}
        </div>
        <div class="card">
          <div class="card-body">
            <a-table
              :columns="columnsCash"
              :rowKey="(record) => record.id"
              :dataSource="cashTransactions"
              :loading="loading"
              :pagination="pagination"
            >
              <template slot="stt" slot-scope="id, record, index">
                {{ index + 1 }}
              </template>
              <template slot="name" slot-scope="title, record">
                <router-link :to="`/admin/cash/${record.id}`">
                  {{ record.displayName }}
                </router-link>
              </template>
              <template slot="content" slot-scope="content, record">
                <router-link :to="`/admin/cash/${record.id}`">
                  {{ content }}
                </router-link>
              </template>
              <template slot="roomInfo" slot-scope="roomInfo">
                {{ roomInfo.name }}
              </template>
              <template slot="time" slot-scope="time">
                {{ time | formatDate }}
              </template>
              <template slot="Current plan" slot-scope="plan">
                {{ plan }}
              </template>
              <template slot="status" slot-scope="status">
                <span :class="`status_${status}`">{{
                  $t("transaction.status_" + status)
                }}</span>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    const columns = [
      {
        title: "#",
        width: "50px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" },
      },
      {
        title: "User",
        dataIndex: "uid",
        scopedSlots: { customRender: "name" },
      },
      {
        title: "Time created",
        dataIndex: "time",
        width: "20%",
        scopedSlots: { customRender: "time" },
      },
      {
        title: "Status",
        width: "15%",
        dataIndex: "status",
        scopedSlots: { customRender: "status" },
      },
    ];
    const columnsCash = [
      {
        title: "#",
        width: "50px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" },
      },
      {
        title: "User",
        dataIndex: "uid",
        scopedSlots: { customRender: "name" },
      },
      {
        title: "Content",
        dataIndex: "content",
        scopedSlots: { customRender: "content" },
      },
      {
        title: "room",
        dataIndex: "roomInfo",
        scopedSlots: { customRender: "roomInfo" },
      },
      {
        title: "Time created",
        dataIndex: "time",
        width: "20%",
        scopedSlots: { customRender: "time" },
      },
      {
        title: "Status",
        width: "15%",
        dataIndex: "status",
        scopedSlots: { customRender: "status" },
      },
    ];
    return {
      columns,
      columnsCash,

      transactions: [],
      cashTransactions: [],
      loading: false,
      displayName: [],
      pagination: {
        pageSize: 5,
      },
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api("admin/transaction")
        .then((res) => {
          this.transactions = res.transactions;
          this.cashTransactions = res.cashTransactions;
          console.log("Data transactions", this.transactions);
          console.log("Data cash", this.cashTransactions);
        })
        .finally((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
.tranTop {
  margin-bottom: 20px;
}
.status_0 {
  color: grey;
}
.status_1 {
  color: green;
}
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
</style>
